import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';

export default class ScreensPlaylistsRoute extends Route {
  @service declare router: RouterService;
  @service declare abilities: AbilitiesService;

  beforeModel(): void {
    if (this.abilities.cannot('view content screens')) {
      this.router.transitionTo('unauthorized');
    }
  }
}
